/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Select the custom select container
    const customSelect = document.querySelector('.custom-select');
    if (customSelect) {
      const selectSelected = customSelect.querySelector('.select-selected');
      const selectItems = customSelect.querySelector('.select-items');

      // Array of filter objects with label, value, and image URL
      const filters = [
        { label: 'Barbeque', value: 'Barbeque', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/barbeque.png' },
        { label: 'Garden Herb Ranch', value: 'Garden+Herb+Ranch', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/garden-herb-ranch.png' },
        { label: 'Honey Mustard', value: 'Honey+Mustard', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/honey-mustard.png' },
        { label: 'Polynesian Sauce', value: 'Polynesian+Sauce', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/polynesian-sauce.png' },
        { label: 'Sweet & Spicy Sriracha', value: 'Sweet+%26+Spicy+Sriracha', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/sweet-spicy-sriracha.png' },
        { label: 'Zesty Buffalo', value: 'Zesty+Buffalo', image: 'https://cdn.shopify.com/s/files/1/0590/0638/6221/files/zesty-buffalo.png' }
      ];

      // Populate the custom select with filter items
      filters.forEach(filter => {
        const filterItem = document.createElement('div');
        filterItem.innerHTML = `<a style="width: 100%;display: flex; align-items: center" href="/collections/sauce/?filter.p.m.custom.filter_tag=${filter.value}"><img src=${filter.image} alt="${filter.label}"><span>${filter.label}</span></a>`;
        selectItems.appendChild(filterItem);
        selectItems.appendChild(filterItem);
      });

      // Toggle the display of the select items
      selectSelected.addEventListener('click', () => {
        selectItems.style.display = selectItems.style.display === 'block' ? 'none' : 'block';
      });

      // Close the dropdown if clicked outside
      document.addEventListener('click', (e) => {
        if (!customSelect.contains(e.target)) {
          selectItems.style.display = 'none';
        }
      });
    }
  });

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  /*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping calculator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });
  */

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  $(document).ready(function() {
    if ($('#text-image-popup').css('display') === 'none') {
          $('.overlay-pop-up-modal').remove();
    } else {
      console.log('The element with ID text-image-popup is visible.');
    }
    $('.close').click(function() {
       $('.overlay-pop-up-modal').remove();
    })
    $('.shop-now-close').click(function(e) {
      e.preventDefault();
      $('.close').trigger('click')
       $('.overlay-pop-up-modal').remove();
      window.location.href = $(this).attr('href');
    })

    
$('.overlay-pop-up-modal').click(function()  {
        $('.close').trigger('click')
})  
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Please agree to our Terms of Service and acknowledge receipt of our Privacy Policy and California Privacy Notice to make a purchase.");
        return false;
      }
    });
  });
  
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
